import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { HiOutlineHome } from "react-icons/hi2";
import {
  PiStudentLight,
  PiChalkboardTeacherThin,
} from "react-icons/pi";
import { FaIdCard } from "react-icons/fa"
import {
  MdOutlineClass,
  MdOutlineSubject,
  MdOutlineNotificationsNone,
  MdOutlineEventAvailable,
  MdMapsHomeWork, MdCurrencyRupee, MdOutlineFactCheck
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../store/slices/auth";
import { FiChevronLeft, FiChevronRight, FiChevronDown } from "react-icons/fi";
import { BsJournals } from "react-icons/bs";
import { IoPeople } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { LuSquareActivity } from "react-icons/lu";
import logoone from "../../assets/favicon.png";
import logotwo from "../../assets/logo-white.png";

const NAV_ITEMS = [
  {
    key: "home",
    label: "Home",
    icon: HiOutlineHome,
    to: "/institute/home",
  },
  {
    key: "classsection",
    label: "Class & Section",
    icon: MdOutlineClass,
    to: "/institute/classandsection",
  },
  {
    key: "staffs",
    label: "Staff",
    icon: PiChalkboardTeacherThin,
    to: "/institute/staffs",
  },

  {
    key: "student",
    label: "Student",
    icon: PiStudentLight,
    to: "/institute/students",
  },

  {
    key: "subject",
    label: "Subject",
    icon: MdOutlineSubject,
    children: [
      { label: "Subject", to: "/institute/subjects" },
      { label: "Class Subject", to: "/institute/classsubjects" },
      { label: "Subject Teacher", to: "/institute/subjectteachers" },
      { label: "Class Teacher", to: "/institute/classteachers" },
    ],
  },

  {
    key: "result",
    label: "Result",
    icon: MdOutlineFactCheck,
    children: [
      { label: "Set Marks", to: "/institute/set-marks" },
      { label: "Result", to: "/institute/result" },

    ],
  },
  {
    key: "homework",
    label: "Homework",
    icon: MdMapsHomeWork,
    to: "/institute/homework",
  },
  // {
  //   key: "diarynote",
  //   label: "Diarynote",
  //   icon: BsJournals,
  //   to: "/institute/diarynote",
  // },
  // {
  //   key: "attendance",
  //   label: "Attendance",
  //   icon: IoPeople,
  //   to: "/institute/attendance",
  // },
  {
    key: "notes",
    label: "Notes",
    icon: CgNotes,
    to: "/institute/notes",
  },
  // {
  //   key: "activity",
  //   label: "Activity",
  //   icon: LuSquareActivity,
  //   to: "/institute/activity",
  // },
  {
    key: "notice",
    label: "Notice",
    icon: MdOutlineNotificationsNone,
    to: "/institute/notices",
  },
  {
    key: "holiday",
    label: "Holiday",
    icon: MdOutlineEventAvailable,
    to: "/institute/holidays",
  },

  {
    key: "fees",
    label: "Fees",
    icon: MdCurrencyRupee,
    children: [
      { label: "Fee Type", to: "/institute/fee-type" },
      { label: "Fee Structure", to: "/institute/fee-structure" },
      { label: "Fee Report", to: "/institute/fees-report" },
    ],
  },

  {
    key: "id",
    label: "ID Card",
    icon: FaIdCard,
    children: [

      { label: "Student ID Card", to: "/institute/student-id" },
      { label: "Staff ID Card", to: "/institute/staff-id" },
    ],
  },
  // {
  //   key: "fees",
  //   label: "Fees",
  //   icon: MdOutlineAttachMoney,
  //   to: "/institute/fees",
  // },

];

export default function SideNavbar({
  collapsed,
  setCollapsed,
  mobileNavOpen,
  setMobileNavOpen,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const closeMobile = () => setMobileNavOpen(false);

  const isChildActive = (children) =>
    children?.some((child) => location.pathname.startsWith(child.to));

  useEffect(() => {
    const activeParent = NAV_ITEMS.find(
      (item) => item.children && isChildActive(item.children)
    );
    setOpenSubmenu(activeParent ? activeParent.key : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (collapsed) setOpenSubmenu(null);
  }, [collapsed]);

  // Clicking ANY icon while collapsed should expand the sidebar first.
  // - Plain link items: expand + navigate.
  // - Parent (with children) items: expand + open that submenu.
  const handleParentClick = (item) => {
    if (collapsed) {
      setCollapsed(false);
      if (item.children) setOpenSubmenu(item.key);
      return;
    }
    setOpenSubmenu((prev) => (prev === item.key ? null : item.key));
  };

  const handlePlainLinkClick = (item, e) => {
    if (collapsed) {
      e.preventDefault();
      setCollapsed(false);
      // Give the expand animation a tick before navigating so the
      // click doesn't feel like it "did nothing" visually.
      navigate(item.to);
      return;
    }
    closeMobile();
  };


  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.auth);

  const instituteLogo = profile?.instituteId?.instituteLogo;


  useEffect(() => {
    if (!profile) {
      dispatch(getProfile());
    }
  }, [dispatch, profile]);

  return (
    <aside
      className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileNavOpen ? "mobile-open" : ""
        }`}
    >
      <div className="sidebar-mobile-close">
        <button onClick={closeMobile}>×</button>
      </div>

      <div className="sidebar-header text-light">
        <div className="sidebar-logo">
          <img
            src={
              instituteLogo
                ? instituteLogo
                : collapsed
                  ? logoone
                  : logotwo
            }
            alt="Institute Logo"
            className={`sidebar-logo-img ${collapsed ? "sidebar-logo-mini" : "sidebar-logo-full"
              }`}
          />
        </div>
        <button
          className="toggle-btn"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
      </div>

      <div className="sidebar-menu">
        <Nav className="flex-column sidebar-nav">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;

            if (item.children) {
              const childActive = isChildActive(item.children);
              const isOpen = openSubmenu === item.key;

              return (
                <div className={`nav-group ${isOpen ? "open" : ""}`} key={item.key}>
                  <div
                    className={`nav-link nav-parent ${childActive ? "active" : ""}`}
                    onClick={() => handleParentClick(item)}
                    data-tooltip={item.label}
                  >
                    <Icon size={18} />
                    {!collapsed && <span className="nav-label">{item.label}</span>}
                    {!collapsed && (
                      <FiChevronDown
                        size={14}
                        className={`submenu-caret ${isOpen ? "rotated" : ""}`}
                      />
                    )}
                    {collapsed && childActive && <span className="active-dot" />}
                  </div>

                  <div
                    className="submenu-wrapper"
                    style={{
                      maxHeight:
                        isOpen && !collapsed
                          ? `${item.children.length * 44}px`
                          : "0px",
                    }}
                  >
                    <div className="submenu">
                      {item.children.map((child) => (
                        <NavLink
                          key={child.to}
                          to={child.to}
                          onClick={closeMobile}
                          className={({ isActive }) =>
                            `submenu-link ${isActive ? "active" : ""}`
                          }
                        >
                          <span className="submenu-dot" />
                          {child.label}
                        </NavLink>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }

            return (
              <div className="nav-group" key={item.key}>
                <NavLink
                  to={item.to}
                  onClick={(e) => handlePlainLinkClick(item, e)}
                  data-tooltip={item.label}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                >
                  <Icon size={18} />
                  {!collapsed && <span className="nav-label">{item.label}</span>}
                </NavLink>
              </div>
            );
          })}
        </Nav>
      </div>
    </aside>
  );
}